<div class="sidebar-panel">
  <div id="sidebar-top-scroll-area flex flex-col" [perfectScrollbar] class="navigation-hold">
    <app-sidenav [items]="menuItems"></app-sidenav>
  </div>
</div>